module.exports = __webpack_public_path__ + "static/media/not-found-img.b9209c45.png";